module.exports = __webpack_public_path__ + "img/step1-02.42e68339.png";